import type { ProductStockItemDto } from "@/types/stock.types";

export type CartLine = {
  productId: string;
  name: string;
  unitPrice: number;
  quantity: number;
  /** What the stock holds, so the basket cannot exceed it. */
  available: number;
};

export function addToCart(lines: CartLine[], item: ProductStockItemDto): CartLine[] {
  const existing = lines.find((line) => line.productId === item.product.id);

  if (!existing) {
    return [
      ...lines,
      {
        productId: item.product.id,
        name: item.product.name,
        unitPrice: item.product.price,
        quantity: 1,
        available: item.quantity,
      },
    ];
  }

  return lines.map((line) =>
    line.productId === item.product.id ? { ...line, quantity: Math.min(line.quantity + 1, line.available) } : line,
  );
}

export function changeQuantity(lines: CartLine[], productId: string, delta: number): CartLine[] {
  return lines
    .map((line) =>
      line.productId === productId
        ? { ...line, quantity: Math.min(Math.max(0, line.quantity + delta), line.available) }
        : line,
    )
    .filter((line) => line.quantity > 0);
}

export function cartTotal(lines: CartLine[]): number {
  return lines.reduce((sum, line) => sum + line.unitPrice * line.quantity, 0);
}
